import React from 'react'
import { Row, Col, Image} from 'react-bootstrap'


const Footer = () => {
    return (
        
        <div className='bg'>
            <div className='container'>
            <Row>
    <Col sm={6}>
    <div className='imagediv'>
    <Image src='/images/footer-img.png' />
            </div>
        </Col>
    <Col sm={6}>
    <div className='thirddiv' >
     <h4>Be a member <br/>    
   of our community &#128519; </h4>
   <p> We’d make sure you’re always first to know what’s <br/>
   happening on Vasiti—thus, the world.
       </p>    
       <div className="contact-input">
        <input
          type="email"
          placeholder="enter your email address..."          
        />
        <p>SUBSCRIBE</p>
       </div>
         </div>
  
    </Col>
  </Row>
        </div>
        <div className='container'>
        <h5>MijiVasiti &copy; 2021</h5>
        </div>
        </div>
    )
}

export  default Footer